import { createMuiTheme } from "@material-ui/core/styles";
// import { paletteDark as palette } from "./palette";
import typography from "./typography";
const darkTheme = createMuiTheme({
  // palette,
  typography,
});
export { darkTheme };
